import { render, staticRenderFns } from "./ui-table.vue?vue&type=template&id=19d2fd7c&scoped=true"
import script from "./ui-table.vue?vue&type=script&lang=js"
export * from "./ui-table.vue?vue&type=script&lang=js"
import style0 from "./ui-table.vue?vue&type=style&index=0&id=19d2fd7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d2fd7c",
  null
  
)

export default component.exports